import {
  CollapsibleDrawer as CollapsibleDrawerComponent,
  CollapsibleDrawerContent,
  type CollapsibleDrawerContentProps,
  type CollapsibleDrawerProps,
  CollapsibleDrawerTrigger,
  type CollapsibleDrawerTriggerProps,
} from './collapsible-drawer';

/**
 * A collapsible drawer component.
 * @param props - The props for the collapsible drawer.
 * @returns The collapsible drawer component.
 *
 * @example
 *  <CollapsibleDrawer title="Test Drawer" side="left" defaultOpen={true}>
 *    <div className="flex flex-col gap-4 p-8 h-screen">
 *      <Text showEllipsis={false}>
 *        This is the main content area. The sidebar will appear on the left side when opened.
 *      </Text>
 *      <CollapsibleDrawer.Trigger>
 *        <Button>Open Left Sidebar</Button>
 *      </CollapsibleDrawer.Trigger>
 *    </div>
 *    <CollapsibleDrawer.Content>
 *       <div className="flex flex-col gap-4">
 *         <Text showEllipsis={false}>
 *          This is a left-positioned sidebar. It slides in from the left side of the screen.
 *        </Text>
 *        <Text showEllipsis={false}>
 *           The content area adjusts its grid layout to accommodate the sidebar when it's open.
 *        </Text>
 *       </div>
 *    </CollapsibleDrawer.Content>
 *   </CollapsibleDrawer>
 */
const CollapsibleDrawer = Object.assign(CollapsibleDrawerComponent, {
  Content: CollapsibleDrawerContent,
  Trigger: CollapsibleDrawerTrigger,
});

export { CollapsibleDrawer };
export type { CollapsibleDrawerProps, CollapsibleDrawerTriggerProps, CollapsibleDrawerContentProps };
